module.exports = __webpack_public_path__ + "img/fh_code_3.a718760d.png";